/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BannedCommunity
 */
export interface BannedCommunity {
    /**
     * 
     * @type {string}
     * @memberof BannedCommunity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BannedCommunity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BannedCommunity
     */
    imgUrl: string;
}

export function BannedCommunityFromJSON(json: any): BannedCommunity {
    return BannedCommunityFromJSONTyped(json, false);
}

export function BannedCommunityFromJSONTyped(json: any, ignoreDiscriminator: boolean): BannedCommunity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imgUrl': json['imgUrl'],
    };
}

export function BannedCommunityToJSON(value?: BannedCommunity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'imgUrl': value.imgUrl,
    };
}


